/* Copyright (c) 2025 MOCA Systems, Inc.  All rights reserved. */

window.isiPad = navigator.userAgent.match(/iPad/i) != null;
